import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProfileSecuritySection = ({ userProfile }) => {
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    if (!dateString) return 'Never changed';
    return new Date(dateString)?.toLocaleDateString('en-US', {
      month: 'long', day: 'numeric', year: 'numeric'
    });
  };

  return (
    <div className="bg-card border border-border rounded-xl p-5">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Lock" size={16} className="text-accent" />
        <h3 className="text-base font-semibold text-foreground">Security</h3>
      </div>

      <div className="flex items-center justify-between py-3 border-b border-border">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-muted flex items-center justify-center">
            <Icon name="Key" size={14} className="text-muted-foreground" />
          </div>
          <div>
            <p className="text-sm font-medium text-foreground">Password</p>
            <p className="text-xs text-muted-foreground">
              Last changed: {formatDate(userProfile?.password_changed_at)}
            </p>
          </div>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={() => navigate('/auth/forgot-password')}
          iconName="ExternalLink"
          iconPosition="right"
        >
          Update Password
        </Button>
      </div>

      <div className="flex items-center justify-between py-3">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-muted flex items-center justify-center">
            <Icon name="Activity" size={14} className="text-muted-foreground" />
          </div>
          <div>
            <p className="text-sm font-medium text-foreground">Account Status</p>
            <p className="text-xs text-muted-foreground">Your account is active</p>
          </div>
        </div>
        <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700 border border-green-200">
          <Icon name="CheckCircle2" size={11} />
          Active
        </span>
      </div>
    </div>
  );
};

export default ProfileSecuritySection;
